import XLSX from 'xlsx'

// Выгрузка сетевых отчётов в Excel: числа уходят числами (Excel их суммирует и сортирует),
// у денег формат с разделителем тысяч, у процентов — «12,5%». Один файл — несколько листов.

const FORMATS = {
	money: '#,##0',
	number: '#,##0.##',
	int: '#,##0',
	percent: '0.0"%"',
}

function sheetName(name, used) {
	let base = String(name || 'Лист').replace(/[[\]:*?/\\]/g, ' ').trim().slice(0, 31) || 'Лист'
	let result = base
	let index = 2
	while (used.has(result)) {
		const suffix = ` (${index++})`
		result = base.slice(0, 31 - suffix.length) + suffix
	}
	used.add(result)
	return result
}

function cellValue(value, type) {
	if (value === null || value === undefined || value === '') return ''
	if (type && type !== 'text') {
		const number = Number(value)
		return isNaN(number) ? value : number
	}
	return value
}

/**
 * sheets: [{
 *   name: 'Продажи',
 *   title: 'Продажи по филиалам',          // первая строка листа
 *   subtitle: 'Период: 01.09.2026 – 30.09.2026',
 *   columns: [{ label: 'Филиал', type: 'text', width: 28 }, { label: 'Выручка', type: 'money' }],
 *   rows: [[...], ...],                    // значения по колонкам
 *   footer: [...],                         // строка итогов (необязательно)
 * }]
 */
export function downloadExcel(fileName, sheets) {
	const workbook = XLSX.utils.book_new()
	const used = new Set()

	sheets.forEach(sheet => {
		const columns = sheet.columns || []
		const aoa = []
		if (sheet.title) aoa.push([sheet.title])
		if (sheet.subtitle) aoa.push([sheet.subtitle])
		if (sheet.title || sheet.subtitle) aoa.push([])
		const headerRow = aoa.length
		aoa.push(columns.map(column => column.label))
		;(sheet.rows || []).forEach(row => {
			aoa.push(row.map((value, index) => cellValue(value, columns[index]?.type)))
		})
		if (sheet.footer) {
			aoa.push(sheet.footer.map((value, index) => cellValue(value, columns[index]?.type)))
		}

		const worksheet = XLSX.utils.aoa_to_sheet(aoa)

		// Форматы чисел по колонкам — для всех строк данных и итога
		columns.forEach((column, columnIndex) => {
			const format = FORMATS[column.type]
			if (!format) return
			for (let rowIndex = headerRow + 1; rowIndex < aoa.length; rowIndex++) {
				const address = XLSX.utils.encode_cell({ r: rowIndex, c: columnIndex })
				const cell = worksheet[address]
				if (cell && cell.t === 'n') cell.z = format
			}
		})

		worksheet['!cols'] = columns.map(column => ({
			wch: column.width || (column.type === 'text' ? 28 : 14),
		}))

		XLSX.utils.book_append_sheet(workbook, worksheet, sheetName(sheet.name, used))
	})

	XLSX.writeFile(workbook, `${fileName}.xlsx`)
}

/** «01.09.2026 – 30.09.2026» из Y-m-d. */
export function periodText(startDate, endDate) {
	const format = (value) => value ? value.split('-').reverse().join('.') : ''
	if (!startDate) return ''
	return startDate === endDate ? format(startDate) : `${format(startDate)} – ${format(endDate)}`
}
